import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const DeminimisPageLayout = ({ title, lg, md, children }) => {
  return (
    <Container fluid>
      <Row>
        <Col className="main-header font-weight-bold">{title}</Col>
      </Row>
      <Row>
        <Col className="header-divider">
          <hr />
        </Col>
      </Row>
      <Row>
        <Col lg={lg} md={md}>
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default DeminimisPageLayout;
